<ng-template #templateRef>
  <mat-card appearance="outlined" style="margin-bottom: 50px; min-width: 60vw;">
    <mat-card-title>Validate or relation has access to an article</mat-card-title>
    <mat-card-content>
      <div class="row">
        <div class="col-md-6">
          <app-relation-selector #relation [filter]="filterRelation" name="Relation" placeholder="Relation" required></app-relation-selector>
        </div>
        <div class="col-md-6">
          <app-article-selector #article [filter]="filterArticle" name="Article" placeholder="Article" required></app-article-selector>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="article.value && relation.value">
    <!-- the article -->
    <ng-container *ngTemplateOutlet="rowTemplate; context: {article: article.value, relation: relation.value}"></ng-container>

    <!-- the parent article -->
    <ng-container *ngIf="article.value.Parent">
      <ng-container *ngTemplateOutlet="rowTemplate; context: {article: article.value.Parent, relation: relation.value, prefix: 'Parent article - '}"></ng-container>
    </ng-container>
  </ng-container>

  <!-- the template -->
  <ng-template #rowTemplate let-article="article" let-prefix="prefix" let-relation="relation">
    <div [class]="isMatch(article, relation)" class="summary">
      <div class="row">
        <div class="col-12">
          <h2 [ngSwitch]="isMatch(article, relation)">
            <span>{{prefix}}</span>
            <ng-container *ngSwitchCase="'match'">Relation {{relation.Code}} HAS access to {{article.Code}}</ng-container>
            <ng-container *ngSwitchCase="'warning'">Relation {{relation.Code}} has LIMITED access to {{article.Code}}
              between {{getMinMatchingDate(article.Groups, relation.Groups) | date: 'shortDate'}}
              and {{getMaxMatchingDate(article.Groups, relation.Groups) | date: 'shortDate'}}</ng-container>
            <ng-container *ngSwitchCase="'article-blocked'">Article {{article.Code}} is blocked</ng-container>
            <ng-container *ngSwitchCase="'relation-blocked'">Relation {{relation.Code}} is blocked</ng-container>
            <ng-container *ngSwitchCase="'nomatch'">Relation {{relation.Code}} does NOT have access to {{article.Code}}</ng-container>
          </h2>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6"><p><strong>Communal groups:</strong><br/>{{getMatchingGroups(article.Groups, relation.Groups).join(', ')}}</p></div>
        <div class="col-md-6"><p><strong>Date limited groups:</strong><br/>{{getDateLimitedGroups(article.Groups, relation.Groups).join(', ')}}</p></div>
        <div class="col-md-6"><p><strong>Missing groups for {{article.Code}}</strong><br/>{{getUnmatchingGroups(article.Groups, relation.Groups).join(', ')}}</p></div>
        <div class="col-md-6"><p><strong>Missing groups for {{relation.Code}}</strong><br/>{{getUnmatchingGroups(relation.Groups, article.Groups).join(', ')}}</p></div>
      </div>
    </div>
  </ng-template>

</ng-template>
